import { Component } from 'vue-property-decorator';
import BaseComponent from '@/components/base/BaseComponent';
import DocumentsAndDeclarationStep from '@/views/dashboard/form101/steps/DocumentsAndDeclarationStep.component.vue';
import EmployerDetailsStep from '@/views/dashboard/form101/steps/EmployerDetailsStep.component.vue';
import PersonalDetailsStep from '@/views/dashboard/form101/steps/personal/PersonalDetailsStep.component.vue';
import ChildrenDetailsStep from '@/views/dashboard/form101/steps/ChildrenDetailsStep.component.vue';
import IncomeDetailsStep from '@/views/dashboard/form101/steps/IncomeDetailsStep.component.vue';
import TaxDetailsStep from '@/views/dashboard/form101/steps/TaxDetailsStep.component.vue';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { FORM_HEADERS, GET_FORM101_AS_PDF, GET_FORM_HEADERS, SET_FORM101_ID } from '@/types/form.types';
import { FormHeaders } from '@/models/Form.model';
import { GridColumn } from '@/models/GridColumn.model';
import { ClickColumn } from '@/models/ClickColumn.model';

@Component({
  components: {
    EmployerDetailsStep,
    PersonalDetailsStep,
    ChildrenDetailsStep,
    IncomeDetailsStep,
    TaxDetailsStep,
    DocumentsAndDeclarationStep,
  },
})
export default class MyFormsComponent extends BaseComponent {

  @Action(GET_FORM_HEADERS, StoreNamespace.FORM) public getFormHeaders;
  @Action(GET_FORM101_AS_PDF, StoreNamespace.FORM) public getForm101AsPdf;

  @Mutation(SET_FORM101_ID, StoreNamespace.FORM) public setForm101Id;
  @Getter(FORM_HEADERS, StoreNamespace.FORM) public formHeaders!: FormHeaders[];

  private columns: GridColumn[] = [];

  public mounted() {
    this.getFormHeaders();
    this.initColumns();
  }

  public onTdClicked(item: any, row: any) {
    switch (row.clickEvent) {
      case 'getForm101AsPdfClicked':
        this.getForm101AsPdfClicked(item.formId);
        break;
    }
  }

  public onRowClicked(item: any) {
    this.setForm101Id(item.formId);
    this.$router.push({ name: 'wizard' });
  }

  private initColumns() {
    this.columns.push({
      property: 'taxYear', header: 'forms.year', hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'revision', header: 'forms.version', hideSorting: true,
    } as GridColumn);
    this.columns.push({
      property: 'statusDesc', header: 'forms.status', hideSorting: true, classProperty: 'status',
    } as GridColumn);
    this.columns.push({
      property: 'updatedDate', header: 'forms.lastUpdated', hideSorting: true,
    } as GridColumn);
    this.columns.push({
      clickEvent: 'getForm101AsPdfClicked', mdIcon: 'picture_as_pdf',
    } as ClickColumn);
    this.columns.push({
      clickEvent: 'onRowClicked',
      mdIcon: 'edit',
    } as ClickColumn);

  }

  private getForm101AsPdfClicked(formDocId: number) {
    this.getForm101AsPdf({
      requestBody: {
        docId: formDocId,
      },
      requestorCallback: this,
    });
  }

  private onPageChange(page: number) {
    this.$emit('onPageChange', page);
  }

  private onRecordsPerPageChanged(records: number) {
    this.$emit('onRecordsPerPageChanged', records);
  }

}
